import { SessionExpired } from "@calorio/api-client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./app/App";
import { OfflineProvider } from "./app/offline";
import { CalorioProvider } from "./app/providers";
import { SessionProvider } from "./app/session";
import "./styles/tokens.css";
import "./styles/app.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 401 means the session is gone; the client already tried a refresh and
      // failed, so retrying is just noise on the way to the sign-in screen —
      // which `SessionProvider` routes to on this same error. The class rather
      // than the message it carries: the wording is a sentence shown to a
      // person, and nothing about retries should depend on how it is phrased.
      retry: (failureCount, error) => failureCount < 2 && !(error instanceof SessionExpired),
      refetchOnWindowFocus: true,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <CalorioProvider>
        <SessionProvider>
          {/* Inside the session, because the queue only drains while signed in
              and a session returning is one of the moments worth retrying on. */}
          <OfflineProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </OfflineProvider>
        </SessionProvider>
      </CalorioProvider>
    </QueryClientProvider>
  </StrictMode>,
);
